import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NbsUserService } from '../services/nbs-user.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {

  constructor(private userService: NbsUserService, private formBuilder: FormBuilder, private toastrService: ToastrService) { }

  destroy$ = new Subject<void>();
  visibleSidebar: boolean;
  displayModal: boolean;
  loginUserName: string;
  loginUserId: number;
  form: FormGroup;

  ngOnInit(): void {
    this.getLoginUserName();
    this.form = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required]
    });
  }

  loggedIn(): boolean {
    this.getUserId();
    this.getLoginUserName();
    return this.userService.loggedIn();
  }

  getUserId() {
    this.loginUserId = this.userService.getUserId();
  }

  getRoleId(): number {
    return this.userService.getRoleId();
  }

  getLoginUserName() {
    this.loginUserName = this.userService.getLoginUserName();
  }

  showModal() {
    this.displayModal = true;
    this.form.controls.oldPassword.setValue("");
    this.form.controls.newPassword.setValue("");
  }

  changePassword() {
    const passwords = {
      oldPassword: this.form.controls.oldPassword.value,
      newPassword: this.form.controls.newPassword.value
    };
    this.userService.changePassword(this.loginUserId, passwords.oldPassword, passwords.newPassword).pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result) {
        this.displayModal = false;
        this.toastrService.success("Şifre değiştirildi.", "BAŞARILI!");
      }
      else {
        this.toastrService.error("Mevcut şifreniz hatalı.", "HATA!");
      }
    })
  }

  logOut() {
    this.userService.logout();
  }

  onDestroy(): void {
    this.destroy$.next();
  }

}
